import { EventBus } from '@/event-bus';
import store from '@/store/index.js';
import postMixin from '@/components/mixins/Posts.vue'
import { getContentSplitting } from '@/utils/networks/twitter/comment.js';
import { maxCharactersByNetworkForText } from '@/components/dash/postCreator/constante.js'
import {
    mergeUpdates,
    deepClone,
    getFilesByNetwork,
    postNetworkValidator,
    unescapeSpecialChars,
    foreachSaveAllFormData,
    findDifferences,
    customModeIsAvailable,
} from './../utils.js'

export default {
    mixins: [postMixin],
    data() {
        return {
        }
    },

    methods: {
        generateDraft(saveAllFormData, pages) {

            saveAllFormData = JSON.parse(JSON.stringify(saveAllFormData))
            console.log("generateDraft", saveAllFormData)
            const replaceMentionsInTextDefault = (text, mentions) => {
                return text.trim().replace(/@(\d{13})/g, (match, id) => {
                    const mention = mentions[id];
                    if (mention) {
                        return mention.textDefault || '';
                    }
                    return match;
                });
            }

            const currentDate = new Date()
            let draft = {}
            draft.tab = this.tab
            draft.idUsersAssigned = this.idUsersAssigned
            draft.requiredValidation = this.requiredValidation
            draft.saveAllFormData = saveAllFormData
            draft.files = Object.fromEntries(Object.entries(this.files).filter(([idFile,dataUpload]) => dataUpload.isUpload))
            draft.form = {
                page: 0,
                name: null,
                url: null,
                file: null,
                date: null,
                time: null,
                title: replaceMentionsInTextDefault(unescapeSpecialChars(saveAllFormData.main.textContent.slice(0, 100).split("\n")[0]), saveAllFormData.main.mentions),
            },

                draft.scheduling = {
                    "lastScheduled": null,
                    "show": true,
                    "date": saveAllFormData.main.planifiedDate && saveAllFormData.main.planifiedDate.date ?
                        new Date(`${saveAllFormData.main.planifiedDate.date}T${saveAllFormData.main.planifiedDate.hours.replace('h', ':')}:00`).toISOString()
                        :
                        currentDate.toISOString(),
                    "time": {
                        "HH": saveAllFormData.main.planifiedDate.hours ? saveAllFormData.main.planifiedDate.hours.split(':')[0] : String(currentDate.getHours()),
                        "mm": saveAllFormData.main.planifiedDate.hours ? saveAllFormData.main.planifiedDate.hours.split(':')[1] : String(currentDate.getMinutes())
                    }
                }
            draft.scheduling.lastScheduled = draft.scheduling.date

            draft.pages = pages.map(page => page.id)
            draft.bot = pages.map(page => page.bots && page.bots.length && page.bots[0].id ? page.bots[0].id : null)

            //enclosure

            const enclosureFile =
                saveAllFormData.main.files.find(file => this.files[file.id] && this.files[file.id].info.type == 'image/gif' && this.files[file.id].isUpload && this.files[file.id].url)
                || saveAllFormData.main.files.find(file => this.files[file.id] && this.files[file.id].info.type2 == 'video' && this.files[file.id].isUpload && this.files[file.id].url)
                || saveAllFormData.main.files.find(file => this.files[file.id] && this.files[file.id].info.type2 == 'image' && this.files[file.id].isUpload && this.files[file.id].url)

            if (enclosureFile) {
                if (this.files[enclosureFile.id].info.type2 == 'video') {
                    if (enclosureFile.imagePreview && enclosureFile.imagePreview.id && this.files[enclosureFile.imagePreview.id]) {
                        draft.form.enclosure = this.files[enclosureFile.imagePreview.id].info.enclosure
                    } else {
                        draft.form.enclosure = this.files[enclosureFile.id].info.enclosure
                    }

                } else {
                    draft.form.enclosure = this.files[enclosureFile.id].url
                }
            }

            draft.editPostValue = []

            pages.forEach(page => {

                let formDataRef = deepClone(saveAllFormData.main)
                if (saveAllFormData.networks[page.network]) mergeUpdates(formDataRef, saveAllFormData.networks[page.network])
                if (saveAllFormData.pages[page.id]) mergeUpdates(formDataRef, saveAllFormData.pages[page.id])


                let edit = {
                    page: page.id
                }

                if (saveAllFormData.main.planifiedDate.date !== formDataRef.planifiedDate.date || saveAllFormData.main.planifiedDate.hours !== formDataRef.planifiedDate.hours) {
                    if (!formDataRef.planifiedDate.date || !formDataRef.planifiedDate.hours) {
                        edit.scheduling = {
                            "date": currentDate.toISOString(),
                            "time": {
                                "HH": String(currentDate.getHours()),
                                "mm": String(currentDate.getMinutes())
                            }
                        }
                    } else {
                        edit.scheduling = {
                            "date": new Date(`${formDataRef.planifiedDate.date}T${formDataRef.planifiedDate.hours.replace('h', ':')}:00`).toISOString(),
                            "time": {
                                "HH": formDataRef.planifiedDate.hours.split(':')[0],
                                "mm": formDataRef.planifiedDate.hours.split(':')[1]
                            }
                        }
                    }
                }

                if (saveAllFormData.main.textContent !== formDataRef.textContent) {
                    edit.title = replaceMentionsInTextDefault(unescapeSpecialChars(formDataRef.textContent.slice(0, 100).split("\n")[0]), formDataRef.mentions)
                }


                edit.video = null
                edit.enclosure = null

                const files = getFilesByNetwork(formDataRef.files, [page.network], { [page.network]: formDataRef.formDataNetwork[page.network] }, this.files, true)[page.network]

                if (files && files.length) {

                    const fileFind = files.find(file => file.type2 == 'image' && file.type == 'image/gif' && this.files[file.id].isUpload && this.files[file.id].url)
                        || files.find(file => file.type2 == 'video' && this.files[file.id].isUpload && this.files[file.id].url)
                        || files.find(file => file.type2 == 'image' && this.files[file.id].isUpload && this.files[file.id].url)

                    if (fileFind) {
                        if (fileFind.type2 == 'video') {
                            edit.video = this.files[fileFind.id].url
                        } else {
                            edit.enclosure = this.files[fileFind.id].url
                        }
                    }
                }


                if (Object.keys(edit).length > 1) {
                    draft.editPostValue = [...draft.editPostValue, edit]
                }
            });

            return draft
        },

        async generateDataFormRequest(cb, pagesSelected, resetWaitValidation = null, resendUpdateNotif = null, autoValidation = null) {

            console.log("generateDataFormRequest", pagesSelected)
            const getErrorObject = (text) => {
                console.log("getErrorObject")
                throw new Error(text)
            };

            const replaceMentionsInTextDefault = (text, mentions) => {
                return text.trim().replace(/@(\d{13})/g, (match, id) => {
                    const mention = mentions[id];
                    if (mention) {
                        return mention.textDefault || '';
                    }
                    return match;
                });
            }

            const troncatText = (text, page) => {
                const maxCharacters = maxCharactersByNetworkForText[page.network]({ page })

                if (page.network == 'twitter' && maxCharacters == 280) {
                    const twttr = require('twitter-text')
                    const parsed = twttr.default.parseTweet(text)

                    if (!parsed.valid) {
                        text = twttr.default.htmlEscape(text).substring(0, parsed.validRangeEnd + 1)
                    } else {
                        return text
                    }
                }


                if (maxCharacters !== Infinity && text.length > maxCharacters) {
                    return Array.from(text).slice(0, maxCharacters).join('')
                }

                return text
            }


            pagesSelected = this.tab == 'story' ? pagesSelected.filter(page => page.network == 'instagram') : pagesSelected
            console.log("pagesSelected", pagesSelected)

            let availableNetworksForPersonalization;
            if (this.tab !== 'story') {
                availableNetworksForPersonalization = customModeIsAvailable({
                    pagesSelected,
                    formDataMain: this.saveAllFormData.main,
                    files: this.files
                })
            }

            const pagesDataForm = await Promise.all(pagesSelected.map(async page => {
                try {
                    if (
                        (!page.bots[0] || !page.bots[0].id || !page.bots[0].status) &&
                        (!page.story_config || !page.story_config.created)
                    ) return getErrorObject("Les services de cette page ne sont pas activés, veuillez la reconnecter ou contacter un administrateur")

                    let formDataRef = deepClone(this.saveAllFormData.main)

                    if (
                        this.tab == 'story' ||
                        (availableNetworksForPersonalization && availableNetworksForPersonalization.includes(page.network))
                    ) {
                        if (this.saveAllFormData.networks[page.network]) mergeUpdates(formDataRef, this.saveAllFormData.networks[page.network])
                        if (this.saveAllFormData.pages[page.id]) mergeUpdates(formDataRef, this.saveAllFormData.pages[page.id])
                    }

                    const dataFormRequest = {
                        bot: page.bots[0].id,
                        service: 'dashboard',
                        allBots: pagesSelected.map(page => page.bots && page.bots.length && page.bots[0].id ? page.bots[0].id : null).join(','),
                        scheduled: formDataRef.planifiedDate && formDataRef.planifiedDate.date ? true : false,
                        data: {
                            videoType: page.network,
                            scheduled_date: formDataRef.planifiedDate && formDataRef.planifiedDate.date ? new Date(`${formDataRef.planifiedDate.date}T${formDataRef.planifiedDate.hours}:00`).toISOString() : undefined,
                        },
                        front_version: localStorage.getItem('front_version') || null

                    }
                    if (dataFormRequest.data.scheduled_date === undefined)
                        delete dataFormRequest.data.scheduled_date;

                    if (this.dataEditPost.excludeNews) {
                        dataFormRequest.data.original = this.dataEditPost.excludeNews
                    }

                    if (this.idUsersAssigned.length) {

                        dataFormRequest.affectedTo = JSON.stringify({
                            "user": this.idUsersAssigned[0],
                            "date": new Date().toISOString().replace('Z', '+00:00'),
                            "users": this.idUsersAssigned,
                            "optionValidation": this.requiredValidation // String(this.requiredValidation) //this.idUsersAssigned.includes(this.currentUser.id) ? 'false' : String(this.requiredValidation)
                        })
                        dataFormRequest.data.resetWaitValidation = resetWaitValidation
                        dataFormRequest.data.resendUpdateNotif = resendUpdateNotif

                        if (this.idUsersAssigned.includes(this.currentUser.id) && this.requiredValidation) {
                            dataFormRequest.wait_validation = JSON.stringify({
                                "name": ` ${this.currentUser.lastname} ${this.currentUser.firstname}`,
                                "email": this.currentUser.email,
                                "date": new Date().toISOString(),
                            })
                        }
                    }

                    const formNetwork = formDataRef.formDataNetwork[page.network]
                    let files = getFilesByNetwork(formDataRef.files, [page.network], { [page.network]: formDataRef.formDataNetwork[page.network] }, this.files, true)[page.network]

                    if (this.tab == 'story') {
                        dataFormRequest.data.videoType = "instagram"
                        dataFormRequest.data.typePost = "story"
                        dataFormRequest.data.postcreator = true
                        dataFormRequest.data.title = ""
                        dataFormRequest.data.stories = JSON.stringify(Object.entries(formDataRef.storification).reduce((acc, [storyId, story]) => {
                            if (!story.hide) {
                                acc[storyId] = story;
                            }
                            return acc;
                        }, {}));
                        dataFormRequest.data.story_standard_api = !(page.story_config && page.story_config.created)
                        // dataFormRequest['data[storification]'] =  JSON.stringify(formDataRef.storification)
                    } else {
                        const postValidator = postNetworkValidator([page.network], { [page.network]: files }, { [page.network]: formDataRef.formDataNetwork[page.network] }, unescapeSpecialChars(formDataRef.textContent))
                        if (!postValidator[page.network].isValid) {
                            return getErrorObject(postValidator[page.network].error[0].textError)
                        }

                        switch (page.network) {
                            case 'instagram': {
                                const replaceMentions = (text, mentions) => {
                                    let mentionCount = 0
                                    return text.trim().replace(/@(\d{13})/g, (match, id) => {
                                        const mention = mentions[id];
                                        if (mention) {
                                            if (mentionCount < 20 && mention.mention && mention.mention.instagram) {
                                                mentionCount++
                                                return `@${mention.mention.instagram.id || mention.mention.instagram.name}`
                                            } else {
                                                return mention.textDefault;
                                            }
                                        }
                                        return match;
                                    });
                                }

                                dataFormRequest.data.title = troncatText(replaceMentions(unescapeSpecialChars(formDataRef.textContent), formDataRef.mentions), page);

                                if (formDataRef.comments.length) {
                                    let comments = formDataRef.comments.reduce((acc, comment) => {
                                        if (comment && comment.trim().length) {
                                            acc.push(troncatText(replaceMentions(unescapeSpecialChars(comment.trim()), formDataRef.mentions), page))
                                        }
                                        return acc;
                                    }, [])

                                    if (comments.length) {
                                        dataFormRequest.data.comments = JSON.stringify(comments);
                                    }
                                }

                                if (formNetwork.collaborators.length || formNetwork.personsIdentified.length) {
                                    dataFormRequest.data.userTags = JSON.stringify({
                                        list: formNetwork.collaborators.concat(formNetwork.personsIdentified).reduce((unique, mention) => {
                                            if (!unique.some(obj => obj.id === mention.id)) {
                                                const index = files.findIndex(file => file.id == mention.idFile)
                                                unique.push({
                                                    name: mention.name,
                                                    x: String(mention.x / 100),
                                                    y: String(mention.y / 100),
                                                    username: mention.id,
                                                    id: mention.pk,
                                                    index: index >= 0 ? index : 0
                                                });
                                            }
                                            return unique;
                                        }, []),
                                        collab: formNetwork.collaborators.map(c => c.pk)
                                    })
                                }

                                if (formNetwork.products.length) {
                                    dataFormRequest.data.productTags = JSON.stringify(
                                        formNetwork.products.map((product) => {

                                            const index = files.findIndex(file => file.id == product.idFile)
                                            return ({
                                                x: String(product.x / 100),
                                                y: String(product.y / 100),
                                                id: product.id,
                                                text: product.text,
                                                description: product.description,
                                                image: null,
                                                merchantId: product.shopId,
                                                index: index >= 0 ? index : 0
                                            });

                                        }, []),

                                    )
                                }


                                if (formNetwork.place && formNetwork.place.id) {
                                    dataFormRequest.data.location = formNetwork.place.id
                                }

                                if (formNetwork.music) {
                                    dataFormRequest.data.music = JSON.stringify({
                                        ...formNetwork.music,
                                        //"duration":formNetwork.data.duration, //duration dans formNetwork
                                        //"start": formNetwork.data.duration, //duration dans formNetwork
                                    })
                                }
                                if (files[0] && files[0].info.enclosure) {
                                    dataFormRequest.data.enclosure = files[0].info.enclosure
                                } else if (files.length > 0 && files[0].type2 === "image") {
                                    dataFormRequest.data.enclosure = files[0].url;
                                }
                                if (dataFormRequest.data.enclosure && formDataRef.files[0].altTextValue) {
                                    dataFormRequest.data.altText = formDataRef.files[0].altTextValue;
                                }

                                if (files.length == 1 && files[0].type2 === "video") {

                                    dataFormRequest.data.videoReel = true //pas obligatoire, marche sans
                                    dataFormRequest.data.videoType = "instagram_reel"
                                    dataFormRequest.data.video = files[0].url
                                    dataFormRequest.data.enclosure = files[0].info.enclosure;

                                    if (files[0].imagePreview && files[0].imagePreview.url) {
                                        dataFormRequest.data.enclosure = files[0].imagePreview.url
                                    }

                                    if (formNetwork.music) {
                                        let duration;
                                        try {
                                            duration = files[0].info.duration * 1000 || await getVideoDuration(files[0].url) * 1000
                                        } catch (error) {
                                            console.error('Erreur lors de la récupération de la durée:', error);
                                            duration = 0
                                        }

                                        dataFormRequest.data.reelStickerConfig = JSON.stringify({
                                            "texts": [],
                                            "music": {
                                                ...formNetwork.music,
                                                "duration": duration,
                                                "startTime": formNetwork.music.track ? formNetwork.music.track.highlight_start_times_in_ms[0] : 0,
                                                "start": 'start' in formNetwork.music ? formNetwork.music.start : formNetwork.music.track ? formNetwork.music.track.highlight_start_times_in_ms[0] : 0,
                                                "end": (formNetwork.music.track ? formNetwork.music.track.highlight_start_times_in_ms[0] : 0) + duration,
                                                "config": false,
                                                "paused": true,
                                            },
                                            "gifs": []
                                        })
                                    }
                                } else {

                                    if (files.find(file => file.type2 == "video")) {
                                        dataFormRequest.data.typePost = 'video'
                                        dataFormRequest.data.postImage = false
                                        dataFormRequest.data.multipleMedias = JSON.stringify(
                                            files.map((file, index) => {
                                                return {
                                                    id: file.id,
                                                    url: file.url,
                                                    thumbnailUrl: file.imagePreview && file.imagePreview.url ? file.imagePreview.url : null,
                                                    name: file.filename,
                                                    type: file.type,
                                                    size: file.size,
                                                };
                                            }),
                                        );
                                    } else {
                                        dataFormRequest.data.typePost = 'image'
                                        dataFormRequest.data.postImage = true
                                        dataFormRequest.data.carrousel = JSON.stringify(
                                            files.map((file, index) => {
                                                let media = {
                                                    id: file.id,
                                                    url: file.url,
                                                    filename: file.filename,
                                                    ratio: formNetwork.ratio == 'auto' ? 0 : formNetwork.ratio.split(':').reduce((a, b) => a / b),
                                                    facebook: index,//? ne sert a rien
                                                    twitter: index,//? ne sert a rien
                                                    linkedin: index,//? ne sert a rien
                                                    uploaded: true
                                                };

                                                if (formDataRef.files[index].altTextValue && formDataRef.files[index].altTextValue != '')
                                                    media.altText = formDataRef.files[index].altTextValue

                                                return media
                                            }),
                                        );
                                    }

                                }

                                if (formNetwork.storification.active) {
                                    // dataFormRequest['data[background_color]'] = '#dcd2ce'

                                    dataFormRequest.data.postcreator = true

                                    if (this.saveAllFormData.networks?.instagram?.formDataNetwork?.instagram?.storification) mergeUpdates(formNetwork.storification, this.saveAllFormData.networks.instagram.formDataNetwork.instagram.storification)
                                    if (this.saveAllFormData.pages?.[page.id]?.formDataNetwork?.instagram?.storification) {
                                        console.log('ici', this.saveAllFormData.pages[page.id].formDataNetwork.instagram.storification)
                                        mergeUpdates(formNetwork.storification, this.saveAllFormData.pages[page.id].formDataNetwork.instagram.storification)
                                        console.log('ici', formNetwork.storification)
                                    }

                                  
                                    if (this.saveAllFormData.networks?.instagram?.storification) mergeUpdates(formDataRef.storification, this.saveAllFormData.networks.instagram.storification)
                                    if (this.saveAllFormData.pages?.[page.id]?.storification) mergeUpdates(formDataRef.storification, this.saveAllFormData.pages[page.id].storification)


                                    dataFormRequest.data.storification = JSON.stringify({
                                        "0": {
                                            ...formDataRef.storification["0"],
                                            shareInFacebook: formNetwork.storification.shareInFacebook,
                                            planifiedDate: formNetwork.storification.planifiedDate
                                        }
                                    });
                                }
                                break;
                            }
                            case 'facebook': {
                                const replaceFacebookMentions = (text, mentions) => {
                                    let mentionCount = 0
                                    return text.trim().replace(/@(\d{13})/g, (match, id) => {
                                        const mention = mentions[id];
                                        if (mention) {
                                            if (mentionCount < 20 && mention.mention && mention.mention.facebook) {
                                                mentionCount++
                                                return `@[${mention.mention.facebook.name} (${mention.mention.facebook.id})]`
                                            } else {
                                                return mention.textDefault
                                            }

                                        }
                                        return match;
                                    });
                                }


                                dataFormRequest.data.title = troncatText(replaceFacebookMentions(
                                    unescapeSpecialChars(formDataRef.textContent),
                                    formDataRef.mentions
                                ), page);


                                if (formDataRef.comments.length) {

                                    let comments = formDataRef.comments.reduce((acc, comment) => {
                                        if (comment && comment.trim().length) {
                                            acc.push(troncatText(replaceFacebookMentions(unescapeSpecialChars(comment.trim()), formDataRef.mentions), page))
                                        }
                                        return acc;
                                    }, [])

                                    if (comments.length) {
                                        dataFormRequest.data.comments = JSON.stringify(comments);
                                    }
                                }


                                if (formNetwork.place && formNetwork.place.id) {
                                    dataFormRequest.data.location = formNetwork.place.id
                                }

                                if (formNetwork.snippet && formNetwork.snippet.link) {
                                    dataFormRequest.data.url = formNetwork.snippet.link
                                    dataFormRequest.data.postImage = false
                                    dataFormRequest.data.videoType = 'facebook'
                                    dataFormRequest.data.typePost = 'standard'
                                } else {
                                    console.log("formNetwork.typeMedia", formNetwork.typeMedia)
                                    if (formNetwork.typeMedia == 'image') {

                                        if (files.length == 1) {
                                            dataFormRequest.data.postImage = true
                                            dataFormRequest.data.typePost = 'image'
                                            dataFormRequest.data.enclosure = files[0].url
                                            if (formDataRef.files[0].altTextValue)
                                                dataFormRequest.data.altText = formDataRef.files[0].altTextValue;
                                        }

                                        if (files.length > 1) {
                                            dataFormRequest.data.postImage = true
                                            dataFormRequest.data.typePost = 'image'
                                            dataFormRequest.data.carrousel = 'image'
                                            dataFormRequest.data.enclosure = files[0].url
                                            dataFormRequest.data.carrousel = JSON.stringify(
                                                files.map((file, index) => {
                                                    let media = {
                                                        url: file.url,
                                                        filename: file.filename,
                                                        size: file.size,
                                                        id: file.id,
                                                        ratio: 1,//? ne sert a rien
                                                        facebook: index,//? ne sert a rien
                                                        twitter: index,//? ne sert a rien
                                                        linkedin: index,//? ne sert a rien
                                                        uploaded: true
                                                    };

                                                    if (formDataRef.files[index].altTextValue && formDataRef.files[index].altTextValue != '')
                                                        media.altText = formDataRef.files[index].altTextValue

                                                    return media
                                                }),
                                            );
                                        }

                                    }

                                    if (formNetwork.typeMedia == 'video' && files.length) {

                                        if (files[0]) {
                                            dataFormRequest.data.postImage = false
                                            dataFormRequest.data.videoType =  /* formNetwork.isReel ? 'facebook_reel' :  */'facebook'
                                            dataFormRequest.data.typePost = 'video'
                                            dataFormRequest.data.video = files[0].url
                                            dataFormRequest.data.enclosure = files[0].info.enclosure;

                                            if (files[0].imagePreview && files[0].imagePreview.url) {
                                                dataFormRequest.data.enclosure = files[0].imagePreview.url
                                                if (page.story_config && page.story_config.created) {
                                                    dataFormRequest.data.addThumbnail = true
                                                }
                                            }
                                        }

                                    }

                                    if (formNetwork.typeMedia == 'mixed' && files.length) {
                                        const firstImage = files.find(f => f.info.type2 == 'image')
                                        const firstVideo = files.find(f => f.info.type2 == 'video')
                                        dataFormRequest.data.enclosure = (firstImage && firstImage.url) || (files[0].info.enclosure)
                                        dataFormRequest.data.postImage = false
                                        dataFormRequest.data.video = firstVideo ? firstVideo.url : undefined
                                        dataFormRequest.data.videoType = 'facebook'
                                        dataFormRequest.data.typePost = 'video'

                                        dataFormRequest.data.multipleMedias = JSON.stringify(files.map((file, index) => {
                                            let media = {
                                                id: file.id,
                                                url: file.url,
                                                thumbnailUrl: file.imagePreview && file.imagePreview.url ? file.imagePreview.url : null,
                                                name: file.info.name,
                                                type: file.info.type,
                                                size: file.info.size
                                            }
                                            if (formDataRef.files[index] && formDataRef.files[index].altTextValue && formDataRef.files[index].altTextValue != '')
                                                media.altText = formDataRef.files[index].altTextValue
                                            return media
                                        }))
                                    }
                                }

                                if (formNetwork.visibility && formNetwork.visibility !== 'all') {
                                    dataFormRequest.data.facebookOptions = JSON.stringify({
                                        visibility: {
                                            all: 'EVERYONE',
                                            friends: 'FRIENDS',
                                            me: 'SELF',
                                        }[formNetwork.visibility]
                                    })
                                }
                                break;
                            }
                            case 'linkedin': {

                                const replaceLinkedInMentions = (text, mentions) => {
                                    return text.trim().replace(/@(\d{13})/g, (match, id) => {
                                        const mention = mentions[id];
                                        if (mention) {
                                            return mention.mention && mention.mention.linkedin
                                                ? `@[${mention.mention.linkedin.name} (${mention.mention.linkedin.id})]`
                                                : mention.textDefault;
                                        }
                                        return match;
                                    });
                                }

                                dataFormRequest.data.title = troncatText(replaceLinkedInMentions(
                                    unescapeSpecialChars(formDataRef.textContent),
                                    formDataRef.mentions
                                ), page);


                                if (formDataRef.comments.length) {
                                    let comments = formDataRef.comments.reduce((acc, comment) => {
                                        if (comment && comment.trim().length) {
                                            acc.push(troncatText(replaceLinkedInMentions(unescapeSpecialChars(comment.trim()), formDataRef.mentions), page))
                                        }
                                        return acc;
                                    }, [])

                                    if (comments.length) {
                                        dataFormRequest.data.comments = JSON.stringify(comments);
                                    }
                                }


                                if (formNetwork.survey && formNetwork.survey.active) {
                                    dataFormRequest.data.postImage = false
                                    dataFormRequest.data.videoType = 'linkedin'
                                    dataFormRequest.data.typePost = 'poll'
                                    dataFormRequest.data.poll = JSON.stringify({
                                        question: formNetwork.survey.question,
                                        options: formNetwork.survey.options,
                                        duration: {
                                            oneDay: 86400,
                                            threeDay: 259200,
                                            oneWeek: 604800,
                                            twoWeek: 1209600
                                        }[formNetwork.survey.duration]
                                    })
                                    // ajout d'un sondage

                                } else {

                                    if (formNetwork.snippet && formNetwork.snippet.link) {
                                        dataFormRequest.data.url = formNetwork.snippet.link
                                        dataFormRequest.data.postImage = false
                                        dataFormRequest.data.videoType = 'linkedin'
                                        dataFormRequest.data.typePost = 'standard'

                                        if (formNetwork.snippet.customActived) {
                                            if (formNetwork.snippet.title) {
                                                dataFormRequest.data.snippetTitle = formNetwork.snippet.title
                                            }

                                            if (
                                                formNetwork.snippet.image &&
                                                formNetwork.snippet.image.id &&
                                                this.files[formNetwork.snippet.image.id] &&
                                                this.files[formNetwork.snippet.image.id].isUpload &&
                                                this.files[formNetwork.snippet.image.id].url
                                            ) {
                                                dataFormRequest.data.snippet = this.files[formNetwork.snippet.image.id].url
                                            }

                                        }

                                    } else if (files.length) {
                                        if (formNetwork.typeMedia == 'video') {


                                            if (files[0]) {
                                                dataFormRequest.data.postImage = false
                                                dataFormRequest.data.videoType = 'linkedin'
                                                dataFormRequest.data.typePost = 'video'
                                                dataFormRequest.data.video = files[0].url
                                                dataFormRequest.data.enclosure = files[0].info.enclosure;

                                                if (files[0].imagePreview && files[0].imagePreview.url) {
                                                    dataFormRequest.data.enclosure = files[0].imagePreview.url
                                                    dataFormRequest.data.addThumbnail = true
                                                }
                                            }

                                        }

                                        if (formNetwork.typeMedia == 'image') {

                                            if (files.length == 1) {
                                                dataFormRequest.data.postImage = true
                                                dataFormRequest.data.typePost = 'image'
                                                dataFormRequest.data.videoType = 'linkedin'
                                                dataFormRequest.data.enclosure = files[0].url
                                                if (formDataRef.files[0].altTextValue)
                                                    dataFormRequest.data.altText = formDataRef.files[0].altTextValue
                                            }

                                            if (files.length > 1) {
                                                dataFormRequest.data.postImage = true
                                                dataFormRequest.data.typePost = 'image'
                                                dataFormRequest.data.carrousel = 'image'
                                                dataFormRequest.data.videoType = 'linkedin'


                                                dataFormRequest.data.enclosure = files[0].url


                                                dataFormRequest.data.carrousel = JSON.stringify(
                                                    files.map((file, index) => {
                                                        let media = {
                                                            url: file.url,
                                                            filename: file.info.filename,
                                                            file: {
                                                                id: file.id,
                                                            },
                                                            size: file.info.size,
                                                            id: file.id,
                                                            ratio: 1,//? ne sert a rien
                                                            facebook: index,//? ne sert a rien
                                                            twitter: index,//? ne sert a rien
                                                            linkedin: index,//? ne sert a rien
                                                            uploaded: true
                                                        }

                                                        if (formDataRef.files[index].altTextValue && formDataRef.files[index].altTextValue != '')
                                                            media.altText = formDataRef.files[index].altTextValue

                                                        return media
                                                    }
                                                    ),
                                                );
                                            }
                                        }

                                        if (formNetwork.typeMedia == 'pdf') {
                                            if (files[0]) {
                                                dataFormRequest.data.postImage = false
                                                dataFormRequest.data.videoType = 'linkedin'
                                                dataFormRequest.data.typePost = 'document'
                                                dataFormRequest.data.documentTitle = files[0].info.customName || files[0].info.name
                                                dataFormRequest.data.enclosure = files[0].info.enclosure
                                                dataFormRequest.data.pdf = files[0].url
                                            }
                                        }
                                    }
                                }

                                break;
                            }
                            case 'google': {
                                dataFormRequest.data.postImage = true
                                dataFormRequest.data.videoType = 'google'
                                dataFormRequest.data.typePost = 'image'

                                dataFormRequest.data.title = troncatText(replaceMentionsInTextDefault(unescapeSpecialChars(formDataRef.textContent), formDataRef.mentions), page);

                                if (files.length) {
                                    dataFormRequest.data.enclosure = files[0].url
                                } else {
                                    if (formNetwork.snippet && formNetwork.snippet.link) {
                                        try {
                                            const { body } = await this.getNewsMeta(formNetwork.snippet.link)
                                            const imageUrl = body?.meta?.og?.image || body?.meta?.image?.[0]?.url || body?.meta?.images?.[0]?.url
                                            if (!imageUrl) return getErrorObject("Veuillez ajouter au moins une image ou un lien.")
                                            dataFormRequest.data.enclosure = imageUrl
                                        } catch (error) {
                                            return getErrorObject("Veuillez ajouter au moins une image ou un lien.")
                                        }
                                    }
                                }

                                if (formNetwork.snippet && formNetwork.snippet.link) {
                                    dataFormRequest.data.url = formNetwork.snippet.link
                                }
                                break;
                            }
                            case 'threads': {
                                dataFormRequest.data.title = troncatText(replaceMentionsInTextDefault(unescapeSpecialChars(formDataRef.textContent), formDataRef.mentions), page);


                                if (formDataRef.comments.length) {

                                    let comments = formDataRef.comments.reduce((acc, comment) => {
                                        if (comment && comment.trim().length) {
                                            acc.push(troncatText(replaceMentionsInTextDefault(unescapeSpecialChars(comment.trim()), formDataRef.mentions), page))
                                        }
                                        return acc;
                                    }, [])

                                    if (comments.length) {
                                        dataFormRequest.data.comments = JSON.stringify(comments);
                                    }
                                }


                                if (!formDataRef.urlsTextContent.length && formNetwork.snippet && formNetwork.snippet.link) {
                                    dataFormRequest.data.url = formNetwork.snippet.link
                                    dataFormRequest.data.postImage = false
                                    dataFormRequest.data.videoType = 'threads'
                                    dataFormRequest.data.typePost = 'standard'
                                } else if (files.length) {

                                    if (files.length == 1) {

                                        if (files[0].info.type2 == 'image') {
                                            dataFormRequest.data.postImage = true
                                            dataFormRequest.data.videoType = 'threads'
                                            dataFormRequest.data.typePost = 'image'
                                            dataFormRequest.data.enclosure = files[0].url
                                            if (formDataRef.files[0].altTextValue)
                                                dataFormRequest.data.altText = formDataRef.files[0].altTextValue;
                                        } else if (files[0].info.type2 == 'video') {
                                            dataFormRequest.data.postImage = false
                                            dataFormRequest.data.videoType = 'threads'
                                            dataFormRequest.data.typePost = 'video'
                                            dataFormRequest.data.video = files[0].url
                                            dataFormRequest.data.enclosure = files[0].info.enclosure;

                                            if (files[0].imagePreview && files[0].imagePreview.url) {
                                                dataFormRequest.data.enclosure = files[0].imagePreview.url
                                                dataFormRequest.data.addThumbnail = true
                                            }
                                        }
                                    } else {
                                        dataFormRequest.data.postImage = false

                                        if (files.find(file => file.info.type2 == 'video')) {
                                            //multi media
                                            dataFormRequest.data.enclosure = files[0].info.enclosure || files.find(file => file.info.type2 == 'image').url
                                            dataFormRequest.data.postImage = false
                                            dataFormRequest.data.video = files.find(file => file.info.type2 == 'video').url
                                            dataFormRequest.data.videoType = 'threads'
                                            dataFormRequest.data.typePost = 'video'

                                            dataFormRequest.data.multipleMedias = JSON.stringify(files.map((file, index) => {
                                                let media = {
                                                    id: file.id,
                                                    url: file.url,
                                                    thumbnailUrl: file.imagePreview && file.imagePreview.url ? file.imagePreview.url : null,
                                                    name: file.info.name,
                                                    type: file.info.type,
                                                    size: file.info.size
                                                }

                                                if (formDataRef.files[index].altTextValue && formDataRef.files[index].altTextValue != '')
                                                    media.altText = formDataRef.files[index].altTextValue

                                                return media
                                            }))

                                        } else {
                                            dataFormRequest.data.enclosure = files[0].info.enclosure || files[0].url
                                            dataFormRequest.data.postImage = true
                                            dataFormRequest.data.videoType = 'threads'
                                            dataFormRequest.data.typePost = 'image'

                                            dataFormRequest.data.carrousel = JSON.stringify(files.map((file, index) => {

                                                let media = {
                                                    url: file.url,
                                                    filename: file.info.name,
                                                    file: {
                                                        id: file.id
                                                    },
                                                    size: file.info.size,
                                                    id: file.id,
                                                    ratio: 1,
                                                    facebook: index,
                                                    twitter: index,
                                                    linkedin: index,
                                                    uploaded: true
                                                }

                                                if (formDataRef.files[index].altTextValue && formDataRef.files[index].altTextValue != '')
                                                    media.altText = formDataRef.files[index].altTextValue

                                                return media
                                            }))
                                        }
                                    }
                                }




                                break;
                            }
                            case 'twitter': {

                                const replaceTwitterMentions = (text, mentions) => {
                                    return text.trim().replace(/@(\d{13})/g, (match, id) => {
                                        const mention = mentions[id];
                                        if (mention) {
                                            return mention.mention && mention.mention.twitter
                                                ? `@${mention.mention.twitter.username}`
                                                : mention.textDefault;
                                        }
                                        return match;
                                    });
                                }

                                dataFormRequest.data.title = troncatText(replaceTwitterMentions(
                                    unescapeSpecialChars(formDataRef.textContent),
                                    formDataRef.mentions
                                ), page);


                                //comments
                                let twitterComments = [];
                                console.log("clemformNetwork", formNetwork, page)
                                if (
                                    formNetwork.tweetSplitting &&
                                    formNetwork.tweetSplitting.active &&
                                    (!page.story_config || !page.story_config.verified_type || page.story_config.verified_type == 'none')
                                ) {
                                    let contents = getContentSplitting(dataFormRequest.data.title);
                                    dataFormRequest.data.title = contents[0];
                                    twitterComments = contents.slice(1);
                                }


                                if (formDataRef.comments.length) {
                                    let comments = formDataRef.comments.reduce((acc, comment) => {
                                        if (comment && comment.trim().length) {
                                            acc.push(troncatText(replaceTwitterMentions(unescapeSpecialChars(comment.trim()), formDataRef.mentions), page))
                                        }
                                        return acc;
                                    }, [])

                                    twitterComments = twitterComments.concat(comments);
                                }

                                if (twitterComments.length) {
                                    dataFormRequest.data.comments = JSON.stringify(twitterComments);
                                }


                                if (formNetwork.snippet && formNetwork.snippet.link) {
                                    dataFormRequest.data.url = formNetwork.snippet.link
                                    dataFormRequest.data.postImage = false
                                    dataFormRequest.data.videoType = 'twitter'
                                    dataFormRequest.data.typePost = 'standard'

                                } else if (files.length) {

                                    if (files[0].info.type2 == 'image') {

                                        if (files.length == 1) {
                                            dataFormRequest.data.postImage = true
                                            dataFormRequest.data.videoType = 'twitter'
                                            dataFormRequest.data.typePost = 'image'
                                            dataFormRequest.data.enclosure = files[0].url
                                            if (formDataRef.files[0].altTextValue)
                                                dataFormRequest.data.altText = formDataRef.files[0].altTextValue;
                                        } else {

                                            dataFormRequest.data.postImage = true
                                            dataFormRequest.data.enclosure = files[0].url
                                            dataFormRequest.data.videoType = 'twitter'
                                            dataFormRequest.data.typePost = 'image'
                                            if (formDataRef.files[0].altTextValue)
                                                dataFormRequest.data.altText = formDataRef.files[0].altTextValue;

                                            dataFormRequest.data.carrousel = JSON.stringify(files.map((file, index) => {

                                                let media = {
                                                    url: file.url,
                                                    filename: file.info.name,
                                                    file: {
                                                        id: file.id,
                                                    },
                                                    size: file.info.size,
                                                    id: file.id,
                                                    ratio: 1,
                                                    facebook: index,
                                                    twitter: index,
                                                    linkedin: index,
                                                    uploaded: true
                                                }

                                                if (formDataRef.files[index].altTextValue && formDataRef.files[index].altTextValue != '')
                                                    media.altText = formDataRef.files[index].altTextValue

                                                return media
                                            }))
                                        }

                                    } else if (files[0].type2 == 'video') {
                                        dataFormRequest.data.postImage = false
                                        dataFormRequest.data.videoType = 'twitter'
                                        dataFormRequest.data.typePost = 'video'
                                        dataFormRequest.data.video = files[0].url
                                        dataFormRequest.data.enclosure = files[0].info.enclosure;

                                        if (files[0].imagePreview && files[0].imagePreview.url) {
                                            dataFormRequest.data.enclosure = files[0].imagePreview.url
                                            dataFormRequest.data.addThumbnail = true
                                        }
                                    }
                                }

                                break;
                            }
                            case 'bluesky': {

                                const replaceBlueskyMentions = (text, mentions) => {
                                    return text.trim().replace(/@(\d{13})/g, (match, id) => {
                                        const mention = mentions[id];
                                        if (mention) {
                                            return mention.mention && mention.mention.bluesky
                                                ? `@${mention.mention.bluesky.subtitle}`
                                                : mention.textDefault;
                                        }
                                        return match;
                                    });
                                }

                                dataFormRequest.data.title = troncatText(replaceBlueskyMentions(
                                    unescapeSpecialChars(formDataRef.textContent),
                                    formDataRef.mentions
                                ), page);


                                //comments
                                let blueskyComments = [];
                                if (formDataRef.comments.length) {
                                    let comments = formDataRef.comments.reduce((acc, comment) => {
                                        if (comment && comment.trim().length) {
                                            acc.push(troncatText(replaceBlueskyMentions(unescapeSpecialChars(comment.trim()), formDataRef.mentions), page))
                                        }
                                        return acc;
                                    }, [])

                                    blueskyComments = comments;
                                }

                                if (blueskyComments.length) {
                                    dataFormRequest.data.comments = JSON.stringify(blueskyComments);
                                }


                                if (formNetwork.snippet && formNetwork.snippet.link) {
                                    dataFormRequest.data.url = formNetwork.snippet.link
                                    dataFormRequest.data.postImage = false
                                    dataFormRequest.data.videoType = 'bluesky'
                                    dataFormRequest.data.typePost = 'standard'

                                } else if (files.length) {

                                    if (files.length > 0 && files[0].type2 === 'video') {
                                        dataFormRequest.data.postImage = false
                                        dataFormRequest.data.video = files[0].url
                                        dataFormRequest.data.typePost = 'video'
                                        dataFormRequest.data.videoType = 'bluesky'
                                        dataFormRequest.data.enclosure = files[0].info.enclosure;
                                        if (files[0].imagePreview && files[0].imagePreview.url) {
                                            dataFormRequest.data.enclosure = files[0].imagePreview.url
                                            dataFormRequest.data.addThumbnail = true
                                        }

                                    } else if (files[0].info.type2 == 'image') {

                                        if (files.length == 1) {
                                            dataFormRequest.data.postImage = true
                                            dataFormRequest.data.videoType = 'bluesky'
                                            dataFormRequest.data.typePost = 'image'
                                            dataFormRequest.data.enclosure = files[0].url
                                            if (formDataRef.files[0].altTextValue)
                                                dataFormRequest.data.altText = formDataRef.files[0].altTextValue;
                                        } else {

                                            dataFormRequest.data.postImage = true
                                            dataFormRequest.data.enclosure = files[0].url
                                            dataFormRequest.data.videoType = 'bluesky'
                                            dataFormRequest.data.typePost = 'image'
                                            if (formDataRef.files[0].altTextValue)
                                                dataFormRequest.data.altText = formDataRef.files[0].altTextValue;

                                            dataFormRequest.data.carrousel = JSON.stringify(files.map((file, index) => {

                                                let media = {
                                                    url: file.url,
                                                    filename: file.info.name,
                                                    file: {
                                                        id: file.id,
                                                    },
                                                    size: file.info.size,
                                                    id: file.id,
                                                    ratio: 1,
                                                    facebook: index,
                                                    bluesky: index,
                                                    linkedin: index,
                                                    uploaded: true
                                                }

                                                if (formDataRef.files[index].altTextValue && formDataRef.files[index].altTextValue != '')
                                                    media.altText = formDataRef.files[index].altTextValue

                                                return media
                                            }))
                                        }
                                    }
                                }

                                break;
                            }
                            case 'tiktok': {

                                const tiktokText = troncatText(replaceMentionsInTextDefault(unescapeSpecialChars(formDataRef.textContent), formDataRef.mentions), page);

                                if (files.length > 0 && files[0].type2 === 'video') {
                                    dataFormRequest.data.title = tiktokText;
                                    dataFormRequest.data.postImage = false
                                    dataFormRequest.data.video = files[0].url
                                    dataFormRequest.data.typePost = 'video'
                                    dataFormRequest.data.videoType = 'tiktok'
                                    dataFormRequest.data.enclosure = files[0].info.enclosure;
                                    if (files[0].imagePreview && files[0].imagePreview.url) {
                                        dataFormRequest.data.enclosure = files[0].imagePreview.url
                                        if (typeof formNetwork.video_cover_timestamp_ms !== 'number') {
                                            dataFormRequest.data.addThumbnail = true
                                        }
                                    }

                                    dataFormRequest.data.tiktokOptions = JSON.stringify(
                                        {
                                            comment_disabled: formNetwork.commentDisable,
                                            duet_disabled: !formNetwork.useVideoForDuo,
                                            stitch_disabled: !formNetwork.useVideoForOtherVideo,
                                            privacy_level: {
                                                all: 'PUBLIC_TO_EVERYONE',
                                                friends: 'MUTUAL_FOLLOW_FRIENDS',
                                                me: 'SELF_ONLY',
                                            }[formNetwork.visibility],
                                            brand_content_toggle: formNetwork.brandContentToggle || false,
                                            brand_organic_toggle: formNetwork.brandOrganicToggle || false,
                                            is_aigc: formNetwork.isAigc || false,
                                            music: formNetwork.music ? JSON.stringify(formNetwork.music) : null,
                                            video_cover_timestamp_ms: formNetwork.video_cover_timestamp_ms,
                                        }
                                    )
                                } else if (files.length > 0 && files[0].type2 === 'image') {
                                    const lines = tiktokText.split('\n');
                                    const title = lines[0] ? Array.from(lines[0]).slice(0, 90).join('') : '';
                                    const description = lines.length > 1 ? Array.from(lines.slice(1).join('\n')).slice(0, 4000).join('') : '';

                                    dataFormRequest.data.title = title;
                                    if (description) {
                                        dataFormRequest.data.description = description;
                                    }
                                    dataFormRequest.data.postImage = true
                                    dataFormRequest.data.typePost = 'image'
                                    dataFormRequest.data.enclosure = files[0].url;
                                    if (formDataRef.files[0].altTextValue)
                                        dataFormRequest.data.altText = formDataRef.files[0].altTextValue;

                                    if (files.length > 1) {
                                        dataFormRequest.data.carrousel = JSON.stringify(
                                            files.map((file, index) => {
                                                let media = {
                                                    url: file.url,
                                                    filename: file.filename,
                                                    uploaded: true
                                                };

                                                if (formDataRef.files[index].altTextValue && formDataRef.files[index].altTextValue != '')
                                                    media.altText = formDataRef.files[index].altTextValue

                                                return media
                                            })
                                        );
                                    }

                                    dataFormRequest.data.tiktokOptions = JSON.stringify(
                                        {
                                            comment_disabled: formNetwork.commentDisable,
                                            privacy_level: {
                                                all: 'PUBLIC_TO_EVERYONE',
                                                friends: 'MUTUAL_FOLLOW_FRIENDS',
                                                me: 'SELF_ONLY',
                                            }[formNetwork.visibility],
                                            auto_add_music: formNetwork.autoAddMusic || false,
                                            photo_cover_index: formNetwork.photoCoverIndex || 0,
                                            brand_content_toggle: formNetwork.brandContentToggle || false,
                                            brand_organic_toggle: formNetwork.brandOrganicToggle || false,
                                        }
                                    )
                                }

                                break;
                            }
                            case 'youtube': {
                                const isShort = files[0].info.aspectRatio == 0.5625

                                if (isShort) {
                                    dataFormRequest.data.title = troncatText(replaceMentionsInTextDefault(unescapeSpecialChars(formDataRef.textContent), formDataRef.mentions), page);
                                } else {
                                    console.log('formDataRef.textContent', formDataRef.textContent)
                                    dataFormRequest.data.title = troncatText(replaceMentionsInTextDefault(unescapeSpecialChars(formDataRef.textContent.slice(0, 100).split("\n")[0]), formDataRef.mentions), page);
                                    dataFormRequest.data.description = troncatText(replaceMentionsInTextDefault(unescapeSpecialChars(formDataRef.textContent.split("\n").slice(1).join("\n")), formDataRef.mentions), page);
                                }


                                dataFormRequest.data.postImage = false
                                dataFormRequest.data.video = files[0].url
                                dataFormRequest.data.videoType = 'youtube'
                                dataFormRequest.data.typePost = 'video'
                                dataFormRequest.data.enclosure = files[0].info.enclosure;
                                if (files[0].imagePreview && files[0].imagePreview.url) {
                                    dataFormRequest.data.enclosure = files[0].imagePreview.url
                                }
                                dataFormRequest.data.youtubeOptions = JSON.stringify({
                                    notifySubscribers: formNetwork.notifySubscribers,
                                    madeForKids: formNetwork.contentForChildren,
                                    privacy_level: {
                                        all: "public",
                                        private: "private",
                                        unlisted: "unlisted"
                                    }[formNetwork.visibility],
                                    category: formNetwork.category,
                                    tag: '', //inutile
                                    tags: formNetwork.tags.length ? formNetwork.tags.map(tagName => ({
                                        text: tagName,
                                        tiClasses: ["valid"]
                                    }))
                                        : [],
                                    playlist: formNetwork.playlistSelectedByPage[page.id] ? formNetwork.playlistSelectedByPage[page.id] : null
                                })


                                break;
                            }
                            case 'pinterest': {

                                if (!formNetwork.boardSelectedByPage[page.id]) return getErrorObject("Aucun board n'a été sélectionné")
                                dataFormRequest.data.boardSelected = formNetwork.boardSelectedByPage[page.id]

                                if (formNetwork.snippet && formNetwork.snippet.link) {
                                    dataFormRequest.data.url = formNetwork.snippet.link
                                }

                                if (!files[0]) {
                                    try {
                                        const { body } = await this.getNewsMeta(formNetwork.snippet.link)
                                        const imageUrl = body.meta.og && body.meta.og.image ? body.meta.og.image : body.meta.image && body.meta.image[0] ? body.meta.image[0].url : null
                                        if (!imageUrl) return getErrorObject("Veuillez ajouter au moins une image ou un lien")

                                        dataFormRequest.data.enclosure = imageUrl
                                        dataFormRequest.data.postImage = true
                                        dataFormRequest.data.videoType = 'pinterest'
                                        dataFormRequest.data.typePost = 'image'

                                    } catch (error) {
                                        return getErrorObject("Veuillez ajouter au moins une image ou un lien")
                                    }
                                }

                                dataFormRequest.data.title = troncatText(replaceMentionsInTextDefault(unescapeSpecialChars(formDataRef.textContent.slice(0, 100).split("\n")[0]), formDataRef.mentions), page);
                                dataFormRequest.data.description = troncatText(replaceMentionsInTextDefault(unescapeSpecialChars(formDataRef.textContent.split("\n").slice(1).join("\n")), formDataRef.mentions), page);

                                if (files[0]) {

                                    if (files[0].type2 == 'video') {
                                        dataFormRequest.data.postImage = false
                                        dataFormRequest.data.video = files[0].url
                                        dataFormRequest.data.videoType = 'pinterest'
                                        dataFormRequest.data.typePost = 'video'
                                        dataFormRequest.data.enclosure = files[0].info.enclosure;
                                        if (files[0].imagePreview && files[0].imagePreview.url) {
                                            dataFormRequest.data.enclosure = files[0].imagePreview.url
                                            dataFormRequest.data.addThumbnail = true
                                        }
                                    } else if (files[0].type2 == 'image') {
                                        dataFormRequest.data.enclosure = files[0].url
                                        dataFormRequest.data.postImage = true
                                        dataFormRequest.data.videoType = 'pinterest'
                                        dataFormRequest.data.typePost = 'image'
                                        if (formDataRef.files[0].altTextValue)
                                            dataFormRequest.data.altText = formDataRef.files[0].altTextValue;
                                    }

                                }
                                break;
                            }
                            case 'telegram': {
                                dataFormRequest.data.title = troncatText(replaceMentionsInTextDefault(unescapeSpecialChars(formDataRef.textContent), formDataRef.mentions), page);
                                dataFormRequest.data.videoType = 'telegram'
                                dataFormRequest.data.typePost = 'standard'

                                if (formDataRef.comments.length) {
                                    let comments = formDataRef.comments.reduce((acc, comment) => {
                                        if (comment && comment.trim().length) {
                                            acc.push(troncatText(replaceMentionsInTextDefault(unescapeSpecialChars(comment.trim()), formDataRef.mentions), page))
                                        }
                                        return acc;
                                    }, [])

                                    if (comments.length) {
                                        dataFormRequest.data.comments = JSON.stringify(comments);
                                    }
                                }

                                break;
                            }
                        }
                    }

                    return [page.id, dataFormRequest]
                } catch (error) {
                    console.log('error', error)
                    return [page.id, {
                        error: error.message
                    }]
                }

            }));

            let pagesDataFormObject = Object.fromEntries(pagesDataForm.filter(data => data !== null))

            const idPagesValid = Object.keys(pagesDataFormObject).filter(id => !pagesDataFormObject[id].hasOwnProperty('error'))

            //generer un draft avec que les pages valide
            if (idPagesValid.length) {
                const draft = JSON.stringify(this.generateDraft(
                    this.saveAllFormData,
                    idPagesValid.map((pageId) => pagesSelected.find(page => page.id == pageId))
                ))
                idPagesValid.forEach(id => {
                    pagesDataFormObject[id]["draft"] = draft
                });
            }
            if (cb) cb(pagesDataFormObject)
            this.dataFormRequest = pagesDataFormObject
            return pagesDataFormObject
        },

        memoizeAsync(fn) {
            const cache = new Map();

            return async function memoized(key, ...args) {
                if (cache.has(key)) {
                    return cache.get(key);
                }

                const p = fn.apply(this, [key, ...args])
                    .catch(err => {
                        cache.delete(key);
                        throw err;
                    });

                cache.set(key, p);
                return p;
            };
        },

        async verifyDynamicUrlInstagram(saveAllFormData, pageId) {
            let isModified = false;
            const saveRequest = {
                music: {},
            }

            async function isUrlAccessible(url) {
                try {
                    const response = await fetch(url, { method: 'HEAD' });
                    return response.ok;
                } catch (error) {
                    return false;
                }
            }

            await foreachSaveAllFormData(saveAllFormData, async (formData, type) => {

                //music instagram
                try {
                    const fdniMusic = formData.formDataNetwork.instagram.music;

                    if (fdniMusic && (fdniMusic.track || fdniMusic.original_sound).progressive_download_url) {
                        const isAccessible = await isUrlAccessible((fdniMusic.track || fdniMusic.original_sound).progressive_download_url);
                        if (!isAccessible) {
                            const trackId = fdniMusic.track ? fdniMusic.track.id : fdniMusic.original_sound.audio_asset_id;
                            if (saveRequest.music[trackId]) {
                                formData.formDataNetwork.instagram.music = saveRequest.music[trackId];
                                isModified = true;
                            } else {
                                const { body } = await this.getMusicInstagram(pageId, `${fdniMusic.track ? fdniMusic.track.display_artist : fdniMusic.original_sound.ig_artist.full_name} ${fdniMusic.track ? fdniMusic.track.title : fdniMusic.original_sound.original_audio_title}`, "music_in_feed")
                                if (body && body.musics && body.musics.length) {
                                    const music = body.musics.find(m => m.track ? m.track.id : m.original_sound.audio_asset_id == trackId);
                                    if (music) {
                                        console.log('music', music)
                                        saveRequest.music[trackId] = music;
                                        formData.formDataNetwork.instagram.music = music;
                                        isModified = true;
                                    } else {
                                        console.warn("Music doesn't exist, warn user to change it", formData.formDataNetwork.instagram.music);
                                        // TODO
                                    }
                                }
                            }
                        }
                    }
                } catch (error) {
                    console.log('Error verifying Instagram music URL:', error);
                }
                // storification 
                if (formData.storification && Object.keys(formData.storification).length > 0) {
                    for (const [storyId, storification] of Object.entries(formData.storification)) {
                        if (storification.stickers && Object.keys(storification.stickers).length > 0) {
                            for (const [stickerId, sticker] of Object.entries(storification.stickers)) {
                                switch (sticker.type) {
                                    case 'product':
                                        // for (const product of sticker.data.products) {
                                        //     if (product.image && product.image.url) {

                                        //     }
                                        // }
                                        break;
                                    case 'music':
                                        const sdMusic = sticker.data.music;
                                        if ((sdMusic.track || sdMusic.original_sound).progressive_download_url) {
                                            const isAccessible = await isUrlAccessible((sdMusic.track || sdMusic.original_sound).progressive_download_url);
                                            if (!isAccessible) {
                                                const trackId = sdMusic.track ? sdMusic.track.id : sdMusic.original_sound.audio_asset_id;
                                                if (saveRequest.music[trackId]) {
                                                    sticker.data.music = saveRequest.music[trackId];
                                                    isModified = true;
                                                } else {
                                                    const { body } = await this.getMusicInstagram(pageId, `${sdMusic.track ? sdMusic.track.display_artist : sdMusic.original_sound.ig_artist.full_name} ${sdMusic.track ? sdMusic.track.title : sdMusic.original_audio_title}`)
                                                    if (body && body.musics && body.musics.length) {
                                                        const music = body.musics.find(m => m.track ? m.track.id : m.original_sound.audio_asset_id == sdMusic.id);
                                                        if (music) {
                                                            console.log('music', music)
                                                            saveRequest.music[trackId] = music;
                                                            sticker.data.music = music
                                                            isModified = true
                                                        } else {
                                                            console.warn("Music doesn't exist, warn user to change it", sticker.data.music);
                                                            // TODO
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        break;
                                    case 'gif':
                                        if (sticker.data.gif.images.original.url) {
                                            const isAccessible = await isUrlAccessible(sticker.data.gif.images.original.url);
                                            if (!isAccessible) {
                                                console.log('GIF URL is not accessible:', sticker.data.gif, sticker.data.gif.images.original.url);
                                                if (saveRequest[sticker.data.gif.images.original.url]) {
                                                    //importer le gif depuis le cache
                                                } else {
                                                    const { data } = await this.searchGifsInstagram(pageId, `@${sticker.data.gif.username || sticker.data.gif.user.username} ${sticker.data.gif.featured_tags.slice(0, 3).join(' ')}`) //sticker.data.gif.title
                                                    if (data && data.gifs && data.gifs.results && data.gifs.results.giphy && data.gifs.results.giphy.length) {
                                                        const gif = data.gifs.results.giphy.find(g => g.id == sticker.data.gif.id);
                                                        sticker.data.gif = gif
                                                        isModified = true
                                                    }
                                                }
                                            }
                                        }
                                        break;
                                    default:
                                        break;
                                }
                            }
                        }
                    }
                }
            });
            console.log('return')
            return { saveAllFormData, isModified }
        },

        generateLog({
            title,
            newFormData,
            lastFormData,
            newIdUsersAssigned,
            lastIdUsersAssigned,
            newRequiredValidation,
            lastRequiredValidation
        }) {
            function capitalize(val) {
                return String(val).charAt(0).toUpperCase() + String(val).slice(1);
            }

            let contentMarkdown = '';



            if (newFormData && lastFormData) {
                // Vérifier les différences entre les données
                const diff = findDifferences(lastFormData, newFormData);

                // Formulaire principal
                if (diff.main && Object.keys(diff.main).length > 0) {
                    contentMarkdown += '## Données principales\n\n';
                    contentMarkdown += '| Propriété | Action |\n';
                    contentMarkdown += '|-----------|--------|\n';

                    Object.entries(diff.main).forEach(([key, value]) => {
                        if (key === 'formDataNetwork') return;
                        contentMarkdown += `| ${key} | modifiée |\n`;
                    });

                    if (diff.main.formDataNetwork) {
                        Object.keys(diff.main.formDataNetwork).forEach(network => {
                            Object.entries(diff.main.formDataNetwork[network]).forEach(([key, value]) => {
                                contentMarkdown += `| ${key} (${network}) | modifiée |\n`;
                            });
                        });
                    }

                }

                // Personnalisation par réseau social
                if (diff.networks && Object.keys(diff.networks).length > 0) {
                    contentMarkdown += '## Personnalisation (Réseau social)\n\n';

                    Object.keys(diff.networks).forEach(network => {
                        contentMarkdown += `### ${capitalize(network)}\n\n`;
                        contentMarkdown += '\n---\n';
                        contentMarkdown += '| Propriété | Action |\n';
                        contentMarkdown += '|-----------|--------|\n';

                        Object.entries(diff.networks[network]).forEach(([key, value]) => {
                            if (key === 'formDataNetwork') return;
                            contentMarkdown += `| ${key} | ${value == 'deleted_value' ? 'supprimé' : 'modifiée'} |\n`;
                        });

                        if (diff.networks[network].formDataNetwork && diff.networks[network].formDataNetwork[network]) {
                            Object.entries(diff.networks[network].formDataNetwork[network]).forEach(([key, value]) => {
                                contentMarkdown += `| ${key} | ${value == 'deleted_value' ? 'supprimé' : 'modifiée'} |\n`;
                            });
                        }
                    });


                }

                // Personnalisation par page
                if (diff.pages && Object.keys(diff.pages).length > 0) {
                    contentMarkdown += '## Personnalisation (Page)\n\n';

                    Object.keys(diff.pages).forEach(pageId => {
                        const page = this.allPages[pageId];
                        contentMarkdown += `### ${capitalize(page.name)}\n\n`;
                        contentMarkdown += '\n---\n';
                        contentMarkdown += '| Propriété | Action |\n';
                        contentMarkdown += '|-----------|--------|\n';

                        Object.entries(diff.pages[pageId]).forEach(([key, value]) => {
                            if (key === 'formDataNetwork') return;
                            contentMarkdown += `| ${key} | ${value == 'deleted_value' ? 'supprimé' : 'modifiée'} |\n`;
                        });

                        if (diff.pages[pageId].formDataNetwork && diff.pages[pageId].formDataNetwork[page.network]) {
                            Object.entries(diff.pages[pageId].formDataNetwork[page.network]).forEach(([key, value]) => {
                                contentMarkdown += `| ${key} | ${value == 'deleted_value' ? 'supprimé' : 'modifiée'} |\n`;
                            });
                        }
                    });


                }

                // Ajouter un en-tête si des changements sont détectés
                if (contentMarkdown) {
                    contentMarkdown = `# Changements détectés:\n\n` + contentMarkdown;
                }
            }


            // Création d'un brouillon | create | save
            // Planifier une publication | create & draft | planifier
            // Souvergarder un brouillon | draft | save
            // Mis a jour une publication | update
            // editer un post plannifier  | edit
            // convertir en brouillon | edit | save

            return {
                user: this.currentUser ?
                    {
                        id: this.currentUser.id,
                        firstname: this.currentUser.firstname,
                        lastname: this.currentUser.lastname,
                        email: this.currentUser.email,
                        avatar: this.currentUser.avatar
                    } : null,
                created_at: new Date().toISOString(),

                title: title,
                content: contentMarkdown.trim(),
            };
        }
    },

    computed: {
        currentUser() {
            return this.$store.getters['users/getCurrentUser']
        },




    }
};
